import { Component, ViewEncapsulation, AfterViewInit, inject, input } from '@angular/core';
import { HelpService } from './help.service';

@Component({
  selector: 'td-wb-help-desktop-article',
  templateUrl: 'help-desktop-article.component.html',
  styleUrls: ['help-desktop-article.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class HelpDesktopArticleComponent implements AfterViewInit {
  private readonly helpService = inject(HelpService);

  readonly articleId = input<string>(undefined);
  readonly articleContent = input<string>(undefined);
  readonly hasFocus = input<boolean>(undefined);

  ngAfterViewInit(): void {
    if (this.hasFocus()) {
      this.helpService.scrollToArticle(this.articleId());
    }
  }
}
